var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button, Table } from 'template/lib';
import useAuth from '../../hooks/useAuth';
import useTitle from '../../hooks/useTitle';
import api from '../../services/api';
import ModalBethaTester from "../Modals/ModalBethaTester";
import { FiPlus } from "react-icons/fi";
import styles from './styles.module.scss';
import Select from 'react-select';
import { BsTrash } from "react-icons/bs";
var BethaTesters = function () {
    var apiUrl = process.env.REACT_APP_API_URL;
    var _a = useAuth(), login = _a.login, handleLogout = _a.handleLogout;
    var setTitle = useTitle().setTitle;
    var history = useHistory();
    var _b = useState(0), idToChange = _b[0], setIdToChange = _b[1];
    var _c = useState([]), items = _c[0], setItems = _c[1];
    var _d = useState(1), page = _d[0], setPage = _d[1];
    var _e = useState(0), totalPages = _e[0], setTotalPages = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var _g = useState(10), pageSize = _g[0], setPageSize = _g[1];
    var _h = useState(false), refresh = _h[0], setRefresh = _h[1];
    var _j = useState(false), hasNext = _j[0], setHasNext = _j[1];
    var enabledProductIds = [
        1032, //PLUGIN LIBRARY
    ];
    var enabledSoftwareIds = [
        2, //3D
    ];
    var _k = useState([]), companiesToSelect = _k[0], setCompaniesToSelect = _k[1];
    var _l = useState({
        label: '',
        value: null
    }), selectedCompany = _l[0], setSelectedCompany = _l[1];
    var _m = useState(null), companyId = _m[0], setCompanyId = _m[1];
    var _o = useState(false), onlySoftwareSelected = _o[0], setOnlySoftwareSelected = _o[1];
    var _p = useState([]), softwaresToSelect = _p[0], setSoftwaresToSelect = _p[1];
    var _q = useState({
        label: '',
        value: null
    }), selectedSoftware = _q[0], setSelectedSoftware = _q[1];
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    var optionsCompanies = (companiesToSelect || []).map(function (item) { return ({
        label: item.name,
        value: item.id
    }); });
    var optionsSoftwares = (softwaresToSelect || []).map(function (item) { return ({
        label: item.name,
        value: item.id
    }); });
    useEffect(function () {
        setTitle('Usuários Betha');
        if (login && Date.now() > login.expiresIn * 1000) {
            handleLogout();
            history.push('/');
            return;
        }
        if (!login) {
            history.push('/');
            return;
        }
        setLoading(true);
        var softwareFilter = selectedSoftware.value ? "softwareId=" + selectedSoftware.value + "&" : '';
        var companyFilter = selectedCompany.value ? "companyId=" + selectedCompany.value + "&" : '';
        api.get("/betha-testers/get-total-pages?" + softwareFilter + companyFilter + "pageSize=" + pageSize, config)
            .then(function (response) {
            setTotalPages(response.data);
            setHasNext(response.data > page);
            LoadBethaTesters(softwareFilter, companyFilter);
        })
            .catch(function (error) {
            console.error('Erro ao carregar total de páginas:', error);
            setTotalPages(0);
            setHasNext(false);
        });
    }, [refresh, page, pageSize, login, selectedSoftware, selectedCompany]);
    useEffect(function () {
        if (!(login === null || login === void 0 ? void 0 : login.token))
            return;
        api.get('/companies', config)
            .then(function (response) {
            var companies = Array.isArray(response.data) ? response.data : [];
            setCompaniesToSelect(companies);
        })
            .catch(function (error) {
            console.error('Erro ao carregar empresas:', error);
            setCompaniesToSelect([]);
        });
        api.get('helps/softwares', config)
            .then(function (response) {
            var softwares = Array.isArray(response.data) ? response.data : [];
            var enabledSoftwares = softwares.filter(function (software) {
                return enabledSoftwareIds.includes(software.id);
            });
            setSoftwaresToSelect(enabledSoftwares);
        })
            .catch(function (error) {
            console.error('Erro ao carregar softwares:', error);
            setSoftwaresToSelect([]);
        });
    }, [login === null || login === void 0 ? void 0 : login.token]);
    useEffect(function () {
        if (optionsSoftwares.length == 1 && onlySoftwareSelected == false) {
            setOnlySoftwareSelected(true);
            var selectedOption = optionsSoftwares[0];
            setSelectedSoftware(selectedOption);
        }
    }, [optionsSoftwares]);
    function LoadBethaTesters(softwareFilter, companyFilter) {
        api.get("/betha-testers?" + softwareFilter + companyFilter + "page=" + page + "&pageSize=" + pageSize, config)
            .then(function (response) {
            setItems(Array.isArray(response.data) ? response.data : []);
        })
            .catch(function (error) {
            console.error('Erro ao carregar usuários betha:', error);
            setItems([]);
        })
            .finally(function () { return setLoading(false); });
    }
    var _r = useState(false), modalIsOpenBethaTester = _r[0], setModalIsOpenBethaTester = _r[1];
    function handleOpenModalBethaTester() {
        setModalIsOpenBethaTester(true);
    }
    function handleCloseModalBethaTester() {
        setModalIsOpenBethaTester(false);
    }
    var handleRemoveAll = function () {
        var confirmed = window.confirm("Deseja realmente remover todos usu\u00E1rios betha?");
        if (!confirmed)
            return;
        console.log('Removendo todos usuários betha');
        api.delete("betha-testers/all", config)
            .then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                setItems([]);
            }
        })
            .catch(function (error) {
            var _a, _b, _c;
            console.log((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
            if ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.hasOwnProperty("detail")) {
                alert("Erro: " + error.response.data.detail);
            }
        })
            .finally(function () {
            setLoading(false);
        });
    };
    var handleRemoveByFilter = function (isSoftware, isCompany) {
        var baseConfirmText = "Deseja realmente remover os usu\u00E1rios betha ";
        var filter = '';
        if (isSoftware && isCompany) {
            baseConfirmText += 'do software e da empresa selecionados?';
            filter = "?softwareId=" + selectedSoftware.value + "&companyId=" + selectedCompany.value;
        }
        else if (isSoftware) {
            baseConfirmText += 'do software selecionado? (Serão removidos de todas as empreas deste software)';
            filter = "?softwareId=" + selectedSoftware.value;
        }
        else if (isCompany) {
            baseConfirmText += 'da empresa selecionada? (Serão removidos de todos os softwares desta empresa)';
            filter = "?companyId=" + selectedCompany.value;
        }
        else {
            return;
        }
        var confirmed = window.confirm(baseConfirmText);
        if (!confirmed)
            return;
        api.delete("betha-testers" + filter, config)
            .then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                setItems([]);
            }
        })
            .catch(function (error) {
            var _a, _b, _c;
            console.log((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
            if ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.hasOwnProperty("detail")) {
                alert("Erro: " + error.response.data.detail);
            }
        })
            .finally(function () {
            setLoading(false);
        });
    };
    var handleRemove = function (id) {
        var confirmed = window.confirm("Deseja realmente remover o usu\u00E1rio betha?\n\nId: " + id);
        if (!confirmed)
            return;
        console.log('Removendo id:', id);
        api.delete("betha-testers/" + id, config)
            .then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                setItems(function (prev) { return prev.filter(function (item) { return item.id !== id; }); });
            }
        })
            .catch(function (error) {
            var _a, _b, _c;
            console.log((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
            if ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.hasOwnProperty("detail")) {
                alert("Erro: " + error.response.data.detail);
            }
        })
            .finally(function () {
            setLoading(false);
        });
    };
    var lineBtns = [
        {
            fn: handleRemove,
            icon: _jsx(BsTrash, { size: 16 }, void 0),
            name: 'Excluir'
        }
    ];
    var menuBtn = [
        {
            fn: function () {
                handleOpenModalBethaTester();
                setRefresh(function (prev) { return !prev; });
            },
            icon: _jsx(FiPlus, { size: 20 }, void 0),
            id: 1,
            title: 'Novo Usuário Betha'
        }
    ];
    var customStyles = {
        control: function (provided) { return (__assign(__assign({}, provided), { minHeight: "20px", boxShadow: 'none', fontSize: "14px !important" })); },
        input: function (provided) { return (__assign(__assign({}, provided), { padding: "0px" })); },
        path: function (provided) { return (__assign(__assign({}, provided), { fill: "black" })); },
        indicatorsContainer: function (provided) { return (__assign(__assign({}, provided), { height: "20px" })); },
        indicatorSeparator: function (provided) { return (__assign(__assign({}, provided), { height: "0px" })); },
        dropdownIndicator: function (provided) { return (__assign(__assign({}, provided), { padding: "2px", color: "black" })); }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: styles.container }, { children: [_jsxs("div", __assign({ className: styles.divSelects }, { children: [_jsxs("div", __assign({ className: styles.selectRows }, { children: [_jsxs("div", __assign({ className: styles.selectContent }, { children: [_jsx("label", { children: "Software:" }, void 0), _jsx(Select, { isClearable: true, styles: customStyles, menuPortalTarget: document.body, placeholder: "Selecione um software", options: optionsSoftwares, id: "selectSoftwareInput", value: selectedSoftware, onChange: function (option) {
                                                    setSelectedSoftware(option || { label: '', value: null });
                                                } }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.buttonsDelete, style: { visibility: (selectedSoftware === null || selectedSoftware === void 0 ? void 0 : selectedSoftware.value) ? 'visible' : 'hidden' } }, { children: _jsx(BsTrash, { title: "Excluir usu\u00E1rios betha do software selecionado", size: 18, className: "cursor-pointer mt-1", onClick: function () { return handleRemoveByFilter(true, false); } }, void 0) }), void 0)] }), void 0), _jsxs("div", __assign({ className: styles.selectRows }, { children: [_jsxs("div", __assign({ className: styles.selectContent }, { children: [_jsx("label", { children: "Empresa:" }, void 0), _jsx(Select, { isClearable: true, styles: customStyles, menuPortalTarget: document.body, placeholder: "Selecione uma empresa", options: optionsCompanies, id: "selectCompanyInput", value: selectedCompany, onChange: function (option) {
                                                    setSelectedCompany(option || { label: '', value: null });
                                                } }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.buttonsDelete, style: { visibility: (selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.value) ? 'visible' : 'hidden' } }, { children: _jsx(BsTrash, { title: "Excluir usu\u00E1rios betha da empresa selecionada", size: 18, className: "cursor-pointer mt-1", onClick: function () { return handleRemoveByFilter(false, true); } }, void 0) }), void 0)] }), void 0), _jsxs("div", __assign({ className: styles.selectRows }, { children: [_jsx(Button, __assign({ onClick: handleRemoveAll }, { children: "Excluir todos usu\u00E1rios betha" }), void 0), _jsx("div", __assign({ style: { visibility: ((selectedSoftware === null || selectedSoftware === void 0 ? void 0 : selectedSoftware.value) && (selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.value)) ? 'visible' : 'hidden' } }, { children: _jsx(Button, __assign({ onClick: function () { return handleRemoveByFilter(true, true); } }, { children: "Excluir usu\u00E1rios betha do software e empresa selecionados" }), void 0) }), void 0)] }), void 0)] }), void 0), _jsx(Table, { setSize: setPageSize, size: pageSize, hasNext: hasNext, page: page, setPage: setPage, data: items, setData: setItems, totalPAges: totalPages, loading: loading, title: 'Usu\u00E1rios Betha', setIdToChange: setIdToChange, refresh: setRefresh, headerButtons: menuBtn, lineButton: lineBtns, columns: [
                            { label: 'ID', key: 'id' },
                            { label: 'Usuário', key: 'userDomain' },
                            { label: 'Número da licença', key: 'licenseNumber' },
                            { label: 'Detalhes', key: 'details' },
                            { label: 'Software', key: 'softwareName' },
                            { label: 'Empresa', key: 'companyName' },
                        ] }, void 0)] }), void 0), _jsx(ModalBethaTester, { refresh: refresh, setRefresh: setRefresh, modalIsOpenBethaTester: modalIsOpenBethaTester, handleOpenModalBethaTester: handleOpenModalBethaTester, handleCloseModalBethaTester: handleCloseModalBethaTester, companyId: selectedCompany.value, enabledSoftwareIds: enabledSoftwareIds, enabledProductIds: enabledProductIds }, void 0)] }, void 0));
};
export default BethaTesters;
